export default __webpack_public_path__ + "static/media/ocean_anchor.add0603f.png";